import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import moment from 'moment';
import Editor from 'src/components/Editor/Editor';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import {
  IBulkKeyPickupResponseSuiteKeyValue,
  IBulkKeyPickupResponseUnit,
} from 'src/services/client-types';
import './BulkKeyPikcupSummary.scss';

interface BulkKeyPickupSummaryProps {
  createdKeyPickups: IBulkKeyPickupResponseUnit[];
}

const BulkKeyPickupSummary = ({
  createdKeyPickups,
}: BulkKeyPickupSummaryProps) => {
  const totalUnits: number = createdKeyPickups.length;

  return (
    <div className="bulk-key-pickup-summary">
      <div className="bulk-key-pickup-summary-success-header">
        <FontAwesomeIcon
          glyph="check-circle"
          weight="solid"
          size="large"
          style={{ color: '#10b981' }}
        />
        <div className="bulk-key-pickup-summary-header-text">
          <h3>Key Pickup Configuration Complete!</h3>
          <p>
            Updated <strong>{totalUnits}</strong> unit
            {totalUnits !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
      <div className="bulk-key-pickup-summary-units-list">
        {createdKeyPickups.map(
          (unit: IBulkKeyPickupResponseUnit, index: number) => (
            <div key={unit.unitId} className="bulk-key-pickup-summary-unit">
              <div className="bulk-key-pickup-summary-unit-header">
                <span className="bulk-key-pickup-summary-title">
                  {unit.number}
                </span>
                <span className="bulk-key-pickup-summary-unit-id">
                  {unit.unitId}
                </span>
              </div>
              {unit.keyHandOffInstructions && (
                <div className="bulk-key-pickup-summary-field">
                  <span className="bulk-key-pickup-summary-label">
                    Instructions:
                  </span>
                  <div className="bulk-key-pickup-summary-field-content">
                    <div className="bulk-key-pickup-summary-instructions">
                      <Editor
                        editorState={unit.keyHandOffInstructions}
                        onEditorStateChange={() => {}}
                        readOnly={true}
                        minHeight={80}
                        resizable={false}
                      />
                    </div>
                  </div>
                </div>
              )}
              {unit.suiteKeysAndValues &&
                unit.suiteKeysAndValues.length > 0 && (
                  <div className="bulk-key-pickup-summary-field">
                    <span className="bulk-key-pickup-summary-label">
                      Additional Details added:
                    </span>
                    <div className="bulk-key-pickup-summary-field-content">
                      <div className="bulk-key-pickup-summary-key-pairs">
                        {unit.suiteKeysAndValues.map(
                          (
                            keysAndValues: IBulkKeyPickupResponseSuiteKeyValue
                          ) => (
                            <CategoryPill
                              key={keysAndValues.id}
                              text={`${keysAndValues.key}: ${keysAndValues.value}`}
                              color="#eff6ff"
                              textColor="#1e40af"
                              size="normal"
                              enabled={true}
                              centerText={false}
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                )}
              <div className="bulk-key-pickup-summary-timestamp">
                Updated {moment(unit.lastModifiedOn).format('MMM DD, h:mm A')}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default BulkKeyPickupSummary;
